import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/atoms/Button";
import InputText from "../../components/atoms/InputText";
import Label from "../../components/atoms/Label";
import { useSessionStorage } from "../../hooks/useSessionStorage";
import styles from "./styles.module.css";
import { jwtDecode } from "jwt-decode";
import { Buffer } from "buffer";
import ErrorDialog from "../../components/molecules/ErrorDialog";
import { MandateStatus, AgreementStatus } from "../../utils/config";

let Digio;

function DigioEMandate() {
  const navigate = useNavigate();
  const [authToken] = useSessionStorage("feemonk_data", "");
  console.log("auth token",authToken)

  const [radioSelectedAccount, setRadioSelectedAccount] = useState("savings");
  const [radioSelectedMandate, setRadioSelectedMandate] = useState("aadhaar");
  const [error, setError] = useState("");

  const [state, setState] = useState({
    accountNumber: "",
    ifscCode: "",
  });

  const { accountNumber, ifscCode } = state;
  const [decoded, setDecoded] = useState<Partial<{userId: string;
    applicationId: string;
    mobile: string;
    validBankDetails: number;
    enachStatus: number;
    agreementStatus: number;
    digilockerStatus: number;
    kycDone: boolean;
    selfieDetails: number;
    isCopplicant: boolean;
    iat: number;
    exp: number;
  }>
>({});
const [mandate, setMandate]=useState(false)

useEffect(() => {
  if (authToken.value) {
    try {
      const decodedToken = jwtDecode(authToken.value);
      setDecoded(decodedToken);
      console.log("Decoded JWT:", decodedToken);
    } catch (error) {
      console.error("JWT Decode Error:", error);
    }
  }
}, [authToken]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_DASHBOARD_URL}/integrations-login/auth`, {
      headers: {
        Authorization: `Bearer ${authToken.value}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (
          data.data?.mandateStatus?.enachStatus === MandateStatus.DigioEmandateSuccessful
        ) {
          navigate("/mandate");
        }
        else if(data.data.agreementStatus===AgreementStatus.Signed || data.data.agreementStatus===AgreementStatus.InvalidSignature || data.data.agreementStatus===AgreementStatus.Skip)
          {
            setMandate(true);
          }
      });
  }, [authToken.value, navigate]);

const returnUrltoken = decoded? Buffer.from(JSON.stringify({ applicationId: decoded.applicationId })).toString("base64") : "";

console.log("returnUrltoken:", returnUrltoken);

  const handleChange = (key:any, val:any) => {
    setState({ ...state, [key]: val });
  };

  const fetchJsFromCDN = (src : any, externals: string[]) => {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.setAttribute("src", src);
      script.addEventListener("load", () => {
        resolve(
          externals.map((key: any) => {
            const ext = window[key];
            if (typeof ext === "undefined") {
              console.warn(`No external named '${key}' in window`);
            }
            return ext;
          })
        );
      });
      script.addEventListener("error", reject);
      document.body.appendChild(script);
    });
  };


  

  // https://app.digio.in/sdk/v11/digio.js
  // https://ext-gateway.digio.in/sdk/v11/digio.js

  async function initiateDigio() {
    console.log("returnUrltoken:", returnUrltoken);
    fetchJsFromCDN("https://app.digio.in/sdk/v11/digio.js", ["Digio"]).then(
      async (digio: any) => {
        Digio = digio[0];
        
        let digioInstance = new Digio({
          environment: "production",
          callback: async function (response : any) {
            console.log("call back res",response)
            if (response.hasOwnProperty("error_code")) {
              console.error("Error occurred:", response.message);
              //added 
              // navigate("/error-page", { state: { errorMessage: response.message } });
              alert(response.message)
              //end
              return;
            }
            console.log("Signing completed successfully:", response.digio_doc_id);

            // const requestOptions = {
            //   method: "POST",
            //   headers: {
            //     "Content-Type": "application/json",
            //     Authorization: `Bearer ${authToken.value}`,
            //   },
            //   body: JSON.stringify({
            //     account_number: accountNumber,
            //     mandate_id: response.digio_doc_id,
            //     ifsc_code: ifscCode,
            //   }),
            // };

            // const result = await fetch(
            //   `${process.env.REACT_APP_DASHBOARD_URL}/mandate/store`,
            //   requestOptions
            // );
            // const storeResponse = await result.json();
            // console.log("Mandate stored successfully:", storeResponse);

            // navigate("/mandate");
            navigate("/thank-you");
          },
          // logo: "https://www.mylogourl.com/image.jpeg",
          theme: {
            primaryColor: "#AB3498",
            secondaryColor: "#000000",
          },
          is_iframe: true,
         
          dg_preferred_auth_type: radioSelectedMandate || "debit",
          // Is_redirection_approach : true,
          // redirect_url : `${process.env.REACT_APP_URL}/${returnUrltoken}`
          // redirect_url : `${process.env.REACT_APP_URL}/thank-you`
        });

        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken.value}`,
          },
          body: JSON.stringify({
            accountNumber,
            accountType: radioSelectedAccount,
            customerMobile: authToken.mob,
            ifsc: ifscCode,
            // customerName: "Dummy",
            authType: radioSelectedMandate,
            userId: decoded.userId,
            applicationId: decoded.applicationId
          }),
        };

        const result = await fetch(
          `${process.env.REACT_APP_DASHBOARD_URL}/digio-emandates/register-emandate`,
          requestOptions
        );
        const response = await result.json();
        console.log("Mandate registration response:", response);

        if (response.mandate_id) {
          digioInstance.init();
          digioInstance.submit(response.mandate_id, authToken.mob);
        }
        else {
          alert(response.message)
        }

       
      }
    );
  }

  async function registerEMandateForAadhar() {
    try {
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken.value}`,
          },
          body: JSON.stringify({
            accountNumber,
            accountType: radioSelectedAccount,
            customerMobile: authToken.mob,
            ifsc: ifscCode,
            authType: radioSelectedMandate,
            userId: decoded.userId,
            applicationId: decoded.applicationId,
          }),
        };

        const result = await fetch(
          `${process.env.REACT_APP_DASHBOARD_URL}/digio-emandates/register-emandate`,
          requestOptions
        );

        const response = await result.json();
        if (response.mandate_id && response.authentication_url) {
          // window.open(response.authentication_url, "_self");
          window.open(`https://app.digio.in/#/gateway/login/${response.access_token.entity_id}/vI3atY/${authToken.mob}?token_id=${response.access_token.id}`, "_self", "noopener,noreferrer");
        }
        else {
          alert(response.message)
        }

        return response;
      } catch (error) {
        console.error("Error registering mandate:", error);
        throw error;
      }
  }



  return (
    <div className={styles.main}>
      <div className={styles.container}>
        {authToken.value && mandate?<><h1>Aadhaar Mandate</h1>
        <div className={styles.inputField}>
          <Label text="Account Number" />
          <InputText
            placeholder="Account Number"
            type="number"
            value={accountNumber}
            changeHandler={(e) => handleChange("accountNumber", e.target.value)}
          />
        </div>
        <div className={styles.inputField}>
          <Label text="IFSC Code" />
          <InputText
            placeholder="IFSC Code"
            type="text"
            value={ifscCode}
            changeHandler={(e) => handleChange("ifscCode", e.target.value)}
          />
        </div>
        <div className={styles.inputField}>
          <Label text="Account Type" />
          <div>
            <input
              type="radio"
              value="savings"
              name="accountType"
              checked={radioSelectedAccount === "savings"}
              onChange={() => setRadioSelectedAccount("savings")}
            /> Savings
            <input
              type="radio"
              value="current"
              name="accountType"
              checked={radioSelectedAccount === "current"}
              onChange={() => setRadioSelectedAccount("current")}
            /> Current
          </div>
        </div>
        <div className={styles.inputField}>
          <Label text="Authentication Method" />
          <div>
            {/* <input
              type="radio"
              value="net_banking"
              name="authMethod"
              checked={radioSelectedMandate === "net_banking"}
              onChange={() => setRadioSelectedMandate("net_banking")}
            /> Net Banking
            <input
              type="radio"
              value="debit"
              name="authMethod"
              checked={radioSelectedMandate === "debit"}
              onChange={() => setRadioSelectedMandate("debit")}
            /> Debit Card */}
            <input
              type="radio"
              value="aadhaar"
              name="authMethod"
              checked={radioSelectedMandate === "aadhaar"}
              onChange={() => setRadioSelectedMandate("aadhaar")}
            /> Aadhaar
          </div>
        </div>
        <Button onPress={() => {
        if (accountNumber.trim() === "") {
          setError("Please Enter Account Number");
          return;
        }

        if (ifscCode.trim() === "") {
          setError("Please Enter IFSC Code");
          return;
        }
          
          // initiateDigio()
          registerEMandateForAadhar()
      }
          } text="SUBMIT" />

          <p>
          Note: Please Wait for 10 Seconds for Mandate Status to get Updated
          Once It is Done.
        </p>
        </>
:<h3>Please Complete Agreement to Proceed <a href="/mandate">Click Here</a></h3>}


      </div>
      {error.trim() && (
        <ErrorDialog error={error} onClose={() => setError(" ")} />
      )}
    </div>
  );
}


export default DigioEMandate;